(() => {
  if (window.__vivienneUpcartPolish) return;
  window.__vivienneUpcartPolish = true;

  const TEXT_REPLACEMENTS = [
    [/Winkelwagen/gi, "Panier"],
    [/Afrekenen/gi, "Passer à la caisse"],
    [/Checkout/gi, "Passer à la caisse"],
    [/Kortingscode/gi, "Code promo"],
    [/Subtotaal/gi, "Sous-total"],
    [/Veilig\s*betalen/gi, "Paiement sécurisé"],
    [/Gratis\s*verzending/gi, "Livraison gratuite"],
    [/7\s*[–-]\s*12\s*Werkdagen/gi, "7-12 jours ouvrés"],
    [/Verwijderen/gi, "Supprimer"],
    [/Kleur\s*:/gi, "Couleur :"],
    [/Schoenmaat\s*:/gi, "Pointure :"],
    [/\bWit\b/gi, "Blanc"],
    [/ROVARO\s*Duo/gi, "Duo Maison"],
    [/Kies 2 deelnemende items voor automatisch 10% voordeel/gi, "Ajoutez 2 articles éligibles pour profiter automatiquement de l'offre."],
    [/Kleding en accessoires\s*·\s*schoenen en veters uitgesloten\./gi, "Articles sélectionnés uniquement. Offre appliquée automatiquement."],
    [/Bekijk selectie/gi, "Voir la sélection"],
    [/Buy\s*1,\s*Get\s*1\s*Free/gi, "1 acheté, 1 offert"],
    [/Size\s*:/gi, "Taille :"],
    [/Color\s*:/gi, "Couleur :"],
    [/Remove/gi, "Supprimer"],
    [/Discount code/gi, "Code promo"],
    [/Secure payment/gi, "Paiement sécurisé"],
    [/Free shipping/gi, "Livraison gratuite"],
    [/Business days/gi, "jours ouvrés"]
  ];

  const STYLE_TEXT = `
    :host {
      --vivienne-cart-ink: #171411;
      --vivienne-cart-muted: #6f675f;
      --vivienne-cart-line: rgba(111, 92, 65, .18);
      --vivienne-cart-tint: #f7f5f1;
      --vivienne-cart-brand: #796548;
      --vivienne-cart-blue-reset: #171411;
    }

    .vivienne-upcart-scope,
    .vivienne-upcart-scope * {
      letter-spacing: normal !important;
      text-rendering: geometricPrecision;
    }

    .vivienne-upcart-scope {
      color: var(--vivienne-cart-ink) !important;
    }

    .vivienne-upcart-title {
      font-size: 15px !important;
      line-height: 1.25 !important;
      font-weight: 600 !important;
      color: var(--vivienne-cart-ink) !important;
    }

    .vivienne-upcart-promo {
      background: var(--vivienne-cart-tint) !important;
      border: 1px solid var(--vivienne-cart-line) !important;
      box-shadow: none !important;
      border-radius: 0 !important;
      color: var(--vivienne-cart-ink) !important;
      padding: 14px 16px !important;
    }

    .vivienne-upcart-promo * {
      color: var(--vivienne-cart-ink) !important;
    }

    .vivienne-upcart-promo a,
    .vivienne-upcart-promo button {
      border-bottom: 1px solid var(--vivienne-cart-ink) !important;
      color: var(--vivienne-cart-ink) !important;
      font-weight: 600 !important;
      text-decoration: none !important;
    }

    .vivienne-upcart-checkout {
      min-height: 52px !important;
      width: 100% !important;
      border-radius: 0 !important;
      border: 1px solid var(--vivienne-cart-ink) !important;
      background: var(--vivienne-cart-ink) !important;
      color: #ffffff !important;
      box-shadow: none !important;
      font-size: 13px !important;
      font-weight: 700 !important;
      letter-spacing: .09em !important;
      text-transform: uppercase !important;
    }

    .vivienne-upcart-checkout:hover {
      background: var(--vivienne-cart-brand) !important;
      border-color: var(--vivienne-cart-brand) !important;
    }

    .vivienne-upcart-checkout:active {
      transform: translateY(1px);
    }

    .vivienne-upcart-discount {
      border-top: 1px solid var(--vivienne-cart-line) !important;
      border-bottom: 1px solid var(--vivienne-cart-line) !important;
      background: #ffffff !important;
      color: var(--vivienne-cart-ink) !important;
    }

    .vivienne-upcart-trust {
      background: #ffffff !important;
      border-top: 1px solid var(--vivienne-cart-line) !important;
      border-bottom: 1px solid var(--vivienne-cart-line) !important;
      color: var(--vivienne-cart-ink) !important;
      font-size: 10px !important;
      font-weight: 700 !important;
      text-transform: uppercase !important;
    }

    .vivienne-upcart-subtotal {
      color: var(--vivienne-cart-ink) !important;
      font-weight: 700 !important;
      text-transform: uppercase !important;
      letter-spacing: .08em !important;
    }

    .vivienne-upcart-muted,
    .vivienne-upcart-muted * {
      color: var(--vivienne-cart-muted) !important;
    }

    .vivienne-upcart-remove {
      color: var(--vivienne-cart-muted) !important;
      font-size: 12px !important;
      text-transform: uppercase !important;
      letter-spacing: .04em !important;
    }

    .vivienne-upcart-qty button,
    .vivienne-upcart-qty input {
      border-color: var(--vivienne-cart-line) !important;
      color: var(--vivienne-cart-ink) !important;
      box-shadow: none !important;
    }

    @media (max-width: 749px) {
      .vivienne-upcart-promo {
        margin: 0 8px 14px !important;
        padding: 13px 14px !important;
      }

      .vivienne-upcart-checkout {
        min-height: 54px !important;
        font-size: 12px !important;
      }

      .vivienne-upcart-title {
        font-size: 14px !important;
      }
    }
  `;

  function textOf(node) {
    return (node && node.textContent ? node.textContent : "").replace(/\s+/g, " ").trim();
  }

  function normalizeText(root) {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        if (!node.nodeValue || !node.nodeValue.trim()) return NodeFilter.FILTER_REJECT;
        if (node.nodeValue.length > 220) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach((node) => {
      let next = node.nodeValue;
      TEXT_REPLACEMENTS.forEach(([pattern, replacement]) => {
        next = next.replace(pattern, replacement);
      });
      if (next !== node.nodeValue) node.nodeValue = next;
    });
  }

  function closestUsefulBox(el) {
    let node = el;
    for (let i = 0; i < 5 && node && node.parentElement; i += 1) {
      const text = textOf(node);
      const rect = node.getBoundingClientRect ? node.getBoundingClientRect() : { width: 0, height: 0 };
      if (text.length > 20 && text.length < 360 && rect.width > 180 && rect.height > 35) return node;
      node = node.parentElement;
    }
    return el;
  }

  function markByText(root) {
    const all = Array.from(root.querySelectorAll("*"));
    all.forEach((el) => {
      const text = textOf(el);
      if (!text) return;

      if (/^Panier(\s*\(\d+\))?$/i.test(text)) {
        el.classList.add("vivienne-upcart-title");
      }

      if (/Duo Maison|Ajoutez 2 articles (e|é)ligibles|Voir la s(e|é)lection/i.test(text)) {
        closestUsefulBox(el).classList.add("vivienne-upcart-promo");
      }

      if (/Code promo/i.test(text)) {
        closestUsefulBox(el).classList.add("vivienne-upcart-discount");
      }

      if (/Paiement s(e|é)curis(e|é)|Livraison gratuite|7-12 jours ouvr(e|é)s/i.test(text)) {
        closestUsefulBox(el).classList.add("vivienne-upcart-trust");
      }

      if (/Sous-total/i.test(text)) {
        el.classList.add("vivienne-upcart-subtotal");
      }

      if (/Supprimer/i.test(text)) {
        el.classList.add("vivienne-upcart-remove");
      }

      if (/Couleur\s*:|Pointure\s*:|Taille\s*:/i.test(text)) {
        el.classList.add("vivienne-upcart-muted");
      }

      if (/^Passer (a|à) la caisse/i.test(text) && /button|a/i.test(el.tagName)) {
        el.classList.add("vivienne-upcart-checkout");
      }

      if (/^Passer (a|à) la caisse/i.test(text) && !/button|a/i.test(el.tagName)) {
        const clickable = el.closest("button, a, [role='button']");
        if (clickable) clickable.classList.add("vivienne-upcart-checkout");
      }

      if ((/^[−\-+]$/.test(text) || /^\d+$/.test(text)) && el.closest("button, input, [role='button']")) {
        closestUsefulBox(el).classList.add("vivienne-upcart-qty");
      }
    });
  }

  function ensureStyle(root) {
    if (root.querySelector && root.querySelector("style[data-vivienne-upcart-polish]")) return;
    const style = document.createElement("style");
    style.setAttribute("data-vivienne-upcart-polish", "true");
    style.textContent = STYLE_TEXT;
    root.appendChild(style);
  }

  function polishRoot(host) {
    const root = host && host.shadowRoot ? host.shadowRoot : host;
    if (!root || !root.querySelectorAll) return false;
    ensureStyle(root);
    const scopeTarget = root.host || host;
    if (scopeTarget && scopeTarget.classList) scopeTarget.classList.add("vivienne-upcart-scope");
    const inner = root.querySelector("[class*='upcart' i], [id*='upcart' i]") || root.firstElementChild;
    if (inner && inner.classList) inner.classList.add("vivienne-upcart-scope");
    normalizeText(root);
    markByText(root);
    return true;
  }

  function findUpcartHost() {
    return document.querySelector("#upCart") ||
      document.querySelector("[id*='upcart' i]") ||
      document.querySelector("[class*='upcart' i]");
  }

  let observer = null;
  let mutationCount = 0;
  const startedAt = Date.now();

  function disconnectSoon() {
    if (observer) {
      observer.disconnect();
      observer = null;
    }
  }

  function attachObserver(host) {
    const root = host && host.shadowRoot ? host.shadowRoot : host;
    if (!root || observer) return;
    observer = new MutationObserver(() => {
      mutationCount += 1;
      if (mutationCount > 80 || Date.now() - startedAt > 12000) {
        disconnectSoon();
        return;
      }
      polishRoot(host);
    });
    observer.observe(root, { childList: true, subtree: true, characterData: true });
    window.setTimeout(disconnectSoon, 12000);
  }

  function run() {
    const host = findUpcartHost();
    if (!host) return false;
    const ok = polishRoot(host);
    attachObserver(host);
    return ok;
  }

  function scheduleUntilReady() {
    if (run()) return;
    if (Date.now() - startedAt > 10000) return;
    window.setTimeout(scheduleUntilReady, 250);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", scheduleUntilReady, { once: true });
  } else {
    scheduleUntilReady();
  }

  ["cart:updated", "cart:open", "ajaxProduct:added", "upcart:open", "upcart:cart_opened"].forEach((eventName) => {
    document.addEventListener(eventName, () => window.setTimeout(run, 80));
  });
})();